import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  LOGIN_AND_CLOSE_URL,
  HTTP_RESPONSE_STATUS_FORBIDDEN_IN_THIS_MONTH,
} from "../config";
import { convertTimestampToKstStr } from "../utils";
import { getLoginStatus } from "../api/sso";
import { downloadRawEventData } from "../api/kquake";
import { setLoginStatus } from "../store/userSlice";
import { TablePageSelector } from "./TablePageSelector";

import DOWNLOAD_20SPS_ICON from "../assets/images/btn_download_2_20.png";
import DOWNLOAD_100SPS_ICON from "../assets/images/btn_download_2_100.png";
import OPEN_20SPS_IMAGE_ICON from "../assets/images/btn_preview_2_20.png";
import OPEN_100SPS_IMAGE_ICON from "../assets/images/btn_preview_2_100.png";
import OPEN_STATION_PGA_IMAGE_ICON from "../assets/images/btn_open_sta_pga_20.png";
import { Trans, useTranslation } from "react-i18next";

const EventRow = React.memo(({ index, event, downloadData }) => {
  // const data_url = {}
  // if (event.data && event.data.urls) {
  //   event.data.urls.forEach((url) => {
  //     if (url.endsWith('acceleration_20sps.zip')) {
  //       data_url.a20 = url
  //     } else if (url.endsWith('acceleration_100sps.zip')) {
  //       data_url.a100 = url
  //     } else if (url.endsWith('velocity_20sps.zip')) {
  //       data_url.v20 = url
  //     } else if (url.endsWith('velocity_100sps.zip')) {
  //       data_url.v100 = url
  //     }
  //   })
  // }

  const additionalInfo = event.additionalInfo;

  return (
    <tr>
      <td>{index}</td>
      <td>{convertTimestampToKstStr(event.origin.time)}</td>
      <td>{event.origin.latitude.toFixed(2)}</td>
      <td>{event.origin.longitude.toFixed(2)}</td>
      <td>{event.origin.depth?.toFixed(0) || "-"}</td>
      <td>{event.magnitude.ML.toFixed(1)}</td>
      <td>{event.intensity}</td>
      <td className="left-align">{event.origin.geolocation}</td>
      {/* <td style={{display: 'flex', flexWrap: 'wrap'}}> */}
      <td>
        {additionalInfo?.wf_vel20 && (
          <>
            <a
              href={`https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/events/${event.id}_velocity_20sps.png`}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={OPEN_20SPS_IMAGE_ICON}
                alt="preview 20 sps velocity data"
                title="미리보기(속도계 20 sps)"
                style={{ width: 25, height: 25 }}
              />
            </a>
            <a
              onClick={(e) => downloadData(additionalInfo.wf_vel20)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={DOWNLOAD_20SPS_ICON}
                alt="download 20 sps velocity data"
                title="다운로드(속도계 20 sps)"
                style={{ width: 25, height: 25 }}
              />
            </a>
          </>
        )}
        {additionalInfo?.wf_vel100 && (
          <>
            <a
              href={`https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/events/${event.id}_velocity_100sps.png`}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={OPEN_100SPS_IMAGE_ICON}
                alt="preview 100 sps velocity data"
                title="미리보기(속도계 100 sps)"
                style={{ width: 25, height: 25 }}
              />
            </a>
            <a
              onClick={(e) => downloadData(additionalInfo.wf_vel100)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={DOWNLOAD_100SPS_ICON}
                alt="download 100 sps velocity data"
                title="다운로드(속도계 100 sps)"
                style={{ width: 25, height: 25 }}
              />
            </a>
          </>
        )}
      </td>
      <td>
        {additionalInfo?.wf_acc20 && (
          <>
            <a
              href={`https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/events/${event.id}_acceleration_20sps.png`}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={OPEN_20SPS_IMAGE_ICON}
                alt="preview 20 sps acceleration data"
                title="미리보기(가속도계 20 sps)"
                style={{ width: 25, height: 25 }}
              />
            </a>
            <a
              onClick={(e) => downloadData(additionalInfo.wf_acc20)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={DOWNLOAD_20SPS_ICON}
                alt="download 20 sps acceleration data"
                title="다운로드(가속도계 100 sps)"
                style={{ width: 25, height: 25 }}
              />
            </a>
          </>
        )}
        {additionalInfo?.wf_acc100 && (
          <>
            <a
              href={`https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/events/${event.id}_acceleration_100sps.png`}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={OPEN_100SPS_IMAGE_ICON}
                alt="preview 100 sps acceleration data"
                title="미리보기(가속도계 100 sps)"
                style={{ width: 25, height: 25 }}
              />
            </a>
            <a
              onClick={(e) => downloadData(additionalInfo.wf_acc100)}
              style={{ cursor: "pointer" }}
            >
              <img
                src={DOWNLOAD_100SPS_ICON}
                alt="download 100 sps acceleration data"
                title="다운로드(가속도계 100 sps)"
                style={{ width: 25, height: 25 }}
              />
            </a>
          </>
        )}
        {additionalInfo?.sta_pga && (
          <a
            href={`https://kr.object.gov-ncloudstorage.com/kerc-kquake-public/web/images/events/${event.id}_station_pga.png`}
            target="_blank"
            rel="noreferrer"
          >
            <img
              src={OPEN_STATION_PGA_IMAGE_ICON}
              alt="image of station PGA values"
              title="PGA-distance curve"
              style={{ width: 25, height: 25 }}
            />
          </a>
        )}
      </td>
    </tr>
  );
});

export const EventsTable = ({ events, setIsLoading }) => {
  useEffect(() => {
    // Init select element
    // https://materializecss.com/select.html
    const elems = document.querySelectorAll("select");
    window.M.FormSelect.init(elems);
  }, []);

  const isLoggedIn = useSelector((state) => state.user.login);
  const apiToken = useSelector((state) => state.user.apiToken);

  const [numOfRowsPerPage, setNumOfRowsPerPage] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);

  const numOfPages = Math.ceil(events.length / numOfRowsPerPage);
  const firstRowIndex = (currentPage - 1) * numOfRowsPerPage;

  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    if (currentPage > numOfPages) {
      setCurrentPage(numOfPages || 1);
    }
  }, [currentPage, numOfPages]);

  const downloadData = useCallback(
    async (dataUrl) => {
      let logInStatus = {};
      if (!isLoggedIn) {
        setIsLoading(true);
        logInStatus = await getLoginStatus();
        if (logInStatus?.status === 200) {
          dispatch(setLoginStatus({ ...logInStatus }));
        }
        setIsLoading(false);
      }

      if (!isLoggedIn && logInStatus?.status !== 200) {
        if (window.confirm(t("form.message.clickDownloadAfterLogin"))) {
          const loginWindow = window.open(LOGIN_AND_CLOSE_URL, "_blank");
          if (loginWindow) {
            loginWindow.focus();
          }
        }
        return;
      }

      const _apiToken =
        logInStatus?.status === 200 ? logInStatus.token : apiToken;
      setIsLoading(true);
      const response = await downloadRawEventData(dataUrl, _apiToken);

      if (response.status === 200) {
        const blob = await response.blob();
        setIsLoading(false);
        const fileName = dataUrl.split("/").slice(-1)[0];
        const a = document.createElement("a");
        a.href = URL.createObjectURL(blob);
        a.setAttribute("download", fileName);
        a.click();
      } else {
        setIsLoading(false);
        if (response.status === 204) {
          alert(
            t("form.message.noDataToDownload") +
              "\r\n" +
              t("form.message.contactAdministrator")
          );
        } else if (response.status === 401) {
          alert(t("form.message.authenticationFailedRefresh"));
        } else if (
          response.status === HTTP_RESPONSE_STATUS_FORBIDDEN_IN_THIS_MONTH
        ) {
          alert(t("form.message.downloadCapacityExceeded"));
        } else {
          const alertMessage = [
            t("form.message.failedToDownload"),
            `Error message:${response.statusText}`,
            t("form.message.contactAdministrator"),
          ];
          alert(alertMessage.join("\r\n"));
        }
      }
    },
    [isLoggedIn, apiToken, dispatch, setIsLoading, t]
  );

  return (
    <>
      <div className="row data_limiter_container">
        <div className="col l10 s6">
          <span className="datalistcount">
            {t("others.tableRowCounter", { rows: events.length })}
          </span>
        </div>
        <div className="col l1 m2 s4 right">
          <select
            value={numOfRowsPerPage}
            onChange={(e) => setNumOfRowsPerPage(e.target.value)}
          >
            <option value={10}>10개씩</option>
            <option value={20}>20개씩</option>
            <option value={40}>40개씩</option>
            <option value={50}>50개씩</option>
          </select>
        </div>
      </div>
      <div className="overflow-auto">
        <table className="table-bordered title-table datatable  table-fixed table_sort highlight centered ">
          <colgroup>
            <col style={{ width: "5%", minWidth: 40 }} />
            <col style={{ width: "17%", minWidth: 136 }} />
            <col style={{ width: "7%", minWidth: 56 }} />
            <col style={{ width: "7%", minWidth: 56 }} />
            <col style={{ width: "5%", minWidth: 40 }} />
            <col style={{ width: "5%", minWidth: 40 }} />
            <col style={{ width: "5%", minWidth: 40 }} />
            <col style={{ width: "24%", minWidth: 192 }} />
            <col style={{ width: "12%", minWidth: 88 }} />
            <col style={{ width: "13%", minWidth: 104 }} />
          </colgroup>
          <tbody>
            <tr>
              <th className="first" rowSpan="2">
                NO.
              </th>
              <th className="first" rowSpan="2">
                {t("page.event-data.table.originTime")}
                <br />
                (KST)
              </th>
              <th className="first" rowSpan="2">
                {t("page.event-data.table.latitude")}
              </th>
              <th className="first" rowSpan="2">
                {t("page.event-data.table.longitude")}
              </th>
              <th className="first" rowSpan="2">
                {t("page.event-data.table.depth")}
                <br />
                (km)
              </th>
              <th className="first" rowSpan="2">
                {t("page.event-data.table.magnitude")}
              </th>
              <th className="first" rowSpan="2">
                {t("page.event-data.table.maximum")}
                <br />
                {t("page.event-data.table.intensity")}
              </th>
              <th className="first" rowSpan="2">
                {t("page.event-data.table.location")}
              </th>
              <th className="first" colSpan="2">
                {t("page.event-data.table.waveformData")}
              </th>
            </tr>
            <tr>
              <th className="first_child">
                {t("page.event-data.table.velocity")}
              </th>
              <th className="first_child">
                {t("page.event-data.table.acceleration")}
              </th>
            </tr>
            {events
              .slice(firstRowIndex, firstRowIndex + numOfRowsPerPage)
              .map((event, index) => (
                <EventRow
                  key={event.catalog + event.origin.time}
                  index={firstRowIndex + index + 1}
                  event={event}
                  downloadData={downloadData}
                />
              ))}
          </tbody>
        </table>
      </div>
      <div className="service-explanation">
        &nbsp;&nbsp;<i className="ion ion-md-information-circle-outline"></i>
        &nbsp;
        <Trans
          i18nKey="page.event-data.resultDesc"
          components={{
            link1: (
              <a
                href="https://www.weather.go.kr/w/eqk-vol/search/korea.do"
                target="_blank"
                rel="noreferrer"
              />
            ),
            underline: <u />,
          }}
        />
      </div>
      <TablePageSelector
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        numOfPages={numOfPages}
      />
    </>
  );
};
